export default __webpack_public_path__ + "static/media/elina.2040d137.png";